import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch7_p01 } from "../../../layouts/ch7_p01/ch7_p01";

export class Chapter7Page1 extends AbstractStoryState implements ReturnType<typeof ch7_p01> {

    readonly bg = this.addChild(new SceneSprite());
    readonly sideBushes = this.addChild(new SceneSprite());
    readonly grassBg = this.addChild(new SceneSprite());
    readonly barn = this.addChild(new SceneSprite());
    readonly grassPath = this.addChild(new SceneSprite());
    readonly shadow = this.addChild(new SceneSprite());
    readonly holly = this.addChild(new SceneSprite());

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch7_p01/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch7_p01/"));

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch7_p01.call(this);

        this.bg.z = 8;
        this.sideBushes.z = 7;
        this.grassBg.z = 6;
        this.barn.z = 5;
        this.grassPath.z = 2;
        this.shadow.z = 1;
        this.holly.z = 1;

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);

        const duration = 3;

        this.makeParallax([
            this.bg,
            this.sideBushes,
            this.grassBg,
            this.barn,
            this.grassPath,
            this.shadow,
            this.holly,
        ], {duration, distance: 8, spread: 10});

        TweenLite.delayedCall(duration, () => {
            this.gotoNextState({ transition: "left" });
        });
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
    }
}